// extracted by mini-css-extract-plugin
module.exports = {"designed":"Designed_designed__YwBGR"};